import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { apiV2 } from "api/firebase";
import { IGetManyCountryQueryRes } from "@evennt-tech/api-v2-external";

type State = {
  countries: IGetManyCountryQueryRes;
  isLoading: boolean;
};

type Action = {
  fetchCountries: (useCached?: boolean) => Promise<void>;
};

export const useCountries = create(
  devtools<State & Action>(
    (set, get) => ({
      isLoading: false,
      countries: [],
      fetchCountries: async (useCached) => {
        if (useCached && get().countries.length) {
          return;
        }
        set({ isLoading: true });
        try {
          const items = await apiV2.country
            .getMany()
            .catch((error) =>
              console.error("Error while loading surcharges: ", error)
            );

          set({ countries: items || [] });
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    { name: "countries" }
  )
);
